'use strict';

exports.__esModule = true;
exports['default'] = createi18n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// needed for String interpolation

var _intlMessageformat = require('intl-messageformat');

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

var _intlFormatCache = require('intl-format-cache');

var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

function createi18n(templateLoader) {
    var locale = arguments[1] === undefined ? _user2['default'].getLocale() : arguments[1];

    return function () {
        for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
            paths[_key] = arguments[_key];
        }

        // returns a local mixin
        return {
            componentWillMount: function componentWillMount() {
                var _this = this;

                templateLoader.languagepacks(paths, function (messages) {
                    if (!_this.messages) {
                        _this.messages = {};
                    }
                    Object.assign(_this.messages, messages);
                    _this.forceUpdate(); // this forces a re-render after the languages have been loaded.
                });
            },

            getMessageFormat: _intlFormatCache2['default'](_intlMessageformat2['default']), // copied from react-intl

            // copied from react-intl
            // returns a formatted and interpolated string
            formatMessage: function formatMessage(message, values) {

                var locales = [locale];

                // TODO: figure out a sensible default
                var formats = this.props.formats || this.context.formats;

                // When `message` is a function, assume it's an IntlMessageFormat
                // instance's `format()` method passed by reference, and call it. This
                // is possible because its `this` will be pre-bound to the instance.
                if (typeof message === 'function') {
                    return message(values);
                }

                if (typeof message === 'string') {
                    message = this.getMessageFormat(message, locales, formats);
                }

                return message.format(values);
            },

            // copied from react-intl
            // Get the template string from the template key
            getIntlMessage: function getIntlMessage(path) {
                var messages = arguments[1] === undefined ? {} : arguments[1];

                var message = undefined;
                var pathParts = path.split('.');

                try {
                    message = pathParts.reduce(function (obj, pathPart) {
                        return obj[pathPart];
                    }, messages);
                } finally {
                    if (message === undefined) {
                        throw new ReferenceError('Could not find Intl message: ' + path);
                    }
                }

                return message;
            },

            i18n: function i18n(message, data) {
                var formattedMessage = undefined;

                // languagepack hat not been loaded yet
                if (!this.messages) {
                    return '';
                }

                // try to load the formatted message with a graceful fallback
                try {
                    formattedMessage = this.getIntlMessage(message, this.messages);
                } catch (error) {
                    if (window.console) {
                        console.warn(error); // eslint-disable-line no-console
                    }
                    formattedMessage = '☃' + message + '☃'; // return with a ☃ message when we can't find the key
                }

                // process any variables that need to be interpolated
                if (data) {
                    formattedMessage = this.formatMessage(formattedMessage, data);
                }

                return formattedMessage;
            }
        };
    };
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react-i18n/dist/createi18n.js
// module id = 194
// module chunks = 0 1 2 4 5 6